export function buildPlanningFilter(filter, allowedFilters, dateOptions = {}) {
    return Object.fromEntries(
        Object.entries(filter)
            .filter(([key]) => allowedFilters.includes(key))
            .map(([key, value]) => {
                // Only wrap team_ids and department_ids with 'id' key and optional dates
                if (key === 'team_ids' || key === 'department_ids') {
                    const wrappedValue = { id: value };

                    // Add date range if provided (for planning components)
                    if (dateOptions.dateStart && dateOptions.dateEnd) {
                        wrappedValue.date_start = dateOptions.dateStart;
                        wrappedValue.date_end = dateOptions.dateEnd;
                    }
                    // Add single date if provided (for list components)
                    else if (dateOptions.date) {
                        wrappedValue.date = dateOptions.date;
                    }

                    return [key, wrappedValue];
                }
                return [key, value];
            })
    );
}